export const ShowHeightFilterPaths = ['/vivara/joias/brincos/argolas-fechadas/']

export const ShowLargerFilterPaths = [
  '/vivara/joias/aliancas/',
  '/vivara/joias/aneis-solitarios/',
]

export const HideLengthFilterPaths = [
  '/life/joias/colares/',
  '/life/joias/correntes/',
]

export const HideLengthMediumFilterPaths = [
  '/vivara/joias/colares/',
  '/vivara/joias/pingentes/',
  '/life/acessorios/',
]

export const HideSizeFilterPaths = ['/life/acessorios/']
